export const ContractorPasswordState = {
    REQUIRED_NEW_PASSWORD: "REQUIRED_NEW_PASSWORD",
    REQUIRED_EXISTING_PASSWORD: "REQUIRED_EXISTING_PASSWORD",
    HAS_PASSWORD_STORED: "HAS_PASSWORD_STORED"
}
